// General
import React, { useContext, useEffect } from "react";
// Styles
import { Modal } from "react-bootstrap";
import { TextField, MenuItem } from "@mui/material";
// Formik
import { Formik, Form } from "formik";
// Contexts
import { BrandsContext } from "../../data/brands/BrandsContext";
import { useValidations } from "../../data/ValidationContext";
// Components
import CapitalizedFormikField from "../../components/CapitalizedFormikField";

const BrandsUpdateModal = ({ isOpen, onClose, brandId }) => {
  // Contextten markalar, güncelleme fonksiyonu ve durum verilerini al
  const { brandsList, updateBrand, statusdata } = useContext(BrandsContext);
  // Validation şeması
  const { vs_brand } = useValidations();

  // Güncellenecek markayı bul
  const brand = brandsList.find((b) => b.id === brandId);
  // Eğer marka bulunamazsa modal render edilmez
  if (!brand) return null;

  // Formik başlangıç değerleri
  const initialValues = {
    name: brand.name,
    description: brand.description,
    status: brand.status,
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered backdrop="static">
      {/* Formik setup */}
      <Formik
        enableReinitialize // initialValues değiştiğinde formu yeniden initialize et
        initialValues={initialValues}
        validationSchema={vs_brand}
        onSubmit={(values) => {
          // Marka adı benzersiz mi kontrol et (kendi ID'si hariç)
          const isDuplicate = brandsList.some(
            (b) =>
              b.id !== brandId &&
              b.name.toLowerCase() === values.name.toLowerCase()
          );
          if (isDuplicate) {
            alert("Bu marka zaten mevcut!");
            return;
          }

          // Marka güncelleme
          updateBrand(brandId, {
            name: values.name,
            description: values.description,
            status: values.status,
          });

          // Modal kapat
          onClose();
        }}
      >
        {({ values, touched, errors, handleChange }) => (
          <Form>
            {/* Modal Header */}
            <Modal.Header closeButton>
              <Modal.Title>Marka Güncelle</Modal.Title>
            </Modal.Header>

            {/* Modal Body */}
            <Modal.Body>
              <div className="d-flex flex-column gap-3">
                {/* Marka Adı */}
                <CapitalizedFormikField
                  name="name"
                  label="Marka Adı"
                  variant="outlined"
                  size="small"
                  fullWidth
                  error={touched.name && !!errors.name}
                  helperText={touched.name && errors.name}
                />

                {/* Açıklama */}
                <CapitalizedFormikField
                  name="description"
                  label="Açıklama"
                  variant="outlined"
                  size="small"
                  fullWidth
                  multiline
                  minRows={2}
                  error={touched.description && !!errors.description}
                  helperText={touched.description && errors.description}
                />

                {/* Durum Seçimi */}
                <CapitalizedFormikField
                  select
                  name="status"
                  label="Durum"
                  value={values.status}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  error={touched.status && !!errors.status}
                  helperText={touched.status && errors.status}
                >
                  {statusdata.map((status) => (
                    <MenuItem key={status} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </CapitalizedFormikField>
              </div>
            </Modal.Body>

            {/* Modal Footer */}
            <Modal.Footer>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Güncelle
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default BrandsUpdateModal;
